import { useContext, useEffect, useState } from "react";
import { State, StateContext } from "../../state";
import { LoginService } from "../../client";
import { T } from "../../i18n";
import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, Typography } from "@mui/material";
import { ArrowDownward, CalendarToday, Email, ExpandMore, Money, Payment, People } from "@mui/icons-material";
import { TourCard } from "../tour/tour_card";
import { mobile } from "../../utils/utils.";
import { RentalDetails } from "../tour/rental";
import { extraDevice } from "../../data/markersData";
import moment from "moment";
import _ from "lodash";


export const Account = () => {

    const { account } = useContext(StateContext) as State;
    const [payments, setPayments] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    if(!account)  {
        window.location.href = "/";
    }

    useEffect(() => {
        setLoading(true)
        LoginService.paymentList().then((x: any) => {
            setPayments(x);
            setLoading(false)
        })
    }, payments)

    const pending = _.sortBy(
        payments.filter((p:any) => ['created_checkout_session', 'paid'].indexOf(p.status) !== -1)
    , '-start');

    const waiting = _.sortBy(
        payments.filter((p:any) => ['waiting_shop_approval'].indexOf(p.status) !== -1)
    , '-start')

    const done = _.sortBy(
        payments.filter((p:any) => ['FINISH'].indexOf(p.status) !== -1)
    , '-start')

    const refounded = _.sortBy(
        payments.filter((p:any) => ['user_free_cancel', 'refusd_by_shop'].indexOf(p.status) !== -1)
    , '-start')

    return (
        <div className="container" style={{paddingTop: '0'}}>
            <div className="pad-20">
                <br/>
                <Typography variant="h3" sx={{fontSize: {xs: '2rem', md: "2.5rem"}}}>{T('my_payments_title')}</Typography>
                <br/>
                <br/>
                {loading &&
                    <CircularProgress />
                }
                {(payments.length === 0 && ! loading) &&
                    <Typography>No Purchases yet</Typography>
                }

                {pending.length > 0 &&
                    <div style={{marginBottom: '60px'}}>
                        <Typography variant="h5">{T('account_pending')}</Typography>
                        <br/>
                        {pending.map((payment:any) => (
                            <PaymentElement payment={payment}/>
                        ))}
                    </div>
                }

                {waiting.length > 0 && 
                    <div style={{marginBottom: '60px'}}>
                        <Typography variant="h5">{T('account_waiting')}</Typography>
                        <br/>
                        {waiting.map((payment:any) => (
                            <PaymentElement payment={payment}/>
                        ))}
                    </div>
                }

                {done.length > 0 &&
                    <div style={{marginBottom: '60px'}}>
                        <Typography variant="h5">{T('account_done')}</Typography>
                        <br/>
                        {done.map((payment:any) => (
                            <PaymentElement payment={payment}/>
                        ))}
                    </div>
                }
                {refounded.length > 0 &&
                    <div style={{marginBottom: '60px'}}>
                        <Typography variant="h5">{T('account_refounded')}</Typography>
                        <br/>
                        {refounded.map((payment:any) => (
                            <PaymentElement payment={payment}/>
                        ))}
                    </div>
                }
            </div>
        </div>
    )
}


export const PaymentElement = ({payment}: any) => {


    const getStatus = (status: string) => {
        switch (status) {
            case 'created_checkout_session':
                return "PAGAMENTO DA EFFETTUARE"
            case 'paid':
                return "PAGAMENTO EFFETTUATO..."
            case 'waiting_shop_approval':
                return "IN ATTESA DI APPROVAZIONE DA PARTE DEL NEGOZIO"
            case 'refusd_by_shop':
                return "RIFIUTATO DAL NEGOZIANTE"
            case 'user_free_cancel':
                return "RIMBORSO EMESSO"
            case 'FINISH':
                return "COMPLETATO"
        }
    }

    const x = payment;

    const start = moment(x.start).format("DD MMMM YYYY")

    return (
        <Accordion
            sx={{boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);", borderRadius: "16px!important", marginBottom: "20px"}}
        >
            <AccordionSummary
                aria-controls="panel1-content"
                id="panel1-header"
                expandIcon={<ExpandMore />}
            >
                <Typography className="row fsb" style={{width: mobile ? 'calc(100% - 10px)': 'auto'}}>{start} <b style={{ marginLeft: mobile ? '0': '20px'}}>{x.amount} €</b></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div style={{marginBottom: "40px", width: "auto"}}>
                    <div className="row gap-40 el-flex" style={{ alignItems: 'flex-start', flexDirection: mobile ? 'column': 'row', padding: mobile ? '0' : '40px'}}>
                        <div>
                            <Typography variant="h5">Purchase details</Typography>
                            <br/>
                            <Typography className="row gap-10" ><CalendarToday/> <b>{T('tour_date2')}:</b> {start}</Typography>
                            <Typography className="row gap-10" ><Payment/> <b>{T('paied')}:</b> {x.amount}€</Typography>
                            <Typography className="row gap-10" ><Email /> <b>{T('status')}:</b> {getStatus(x.status)}</Typography>
                            <Typography className="row gap-10" ><People/> <b>{T('partecipants')}:</b> {x.partecipants}</Typography>
                            <br/>
                            {x.tour && x.items.length > 0 &&
                                <>
                                    <Typography variant="h5">{T('rent_title')}</Typography>
                                    <div style={{ padding: mobile ? '0': '15px'}}>
                                    <RentalDetails
                                        catalogue={[x.tour.catalogue, ...extraDevice]}
                                        items={x.items}
                                        days={x.tour.routes.length}
                                        readonly
                                        compact
                                        checkoutMode
                                        extraClass='account-rental'
                                    />
                                    </div>
                                </>
                            }
                        </div>
                        {x.tour && 
                            <div className="col" style={{alignItems: mobile ? 'flex-start' : "flex-end"}}>
                                <Typography variant="h5">Selected tour</Typography>
                                <br/>
                                <TourCard tour={x.tour} />
                            </div>
                        }
                    </div>
                    <div className="row gap-40 el-flex" style={{ alignItems: 'flex-start', flexDirection: mobile ? 'column': 'row', padding: mobile ? '20px 0 0 0' : '40px'}}>
                        <div>
                        {(x.activation_link && x.status === 'FINISH') && (
                            <>
                                <Typography variant="h5">Activation mode</Typography>
                                <br/>
                                <Typography>1 - <a href="https://admin.outdoora.app/api/download/" target="_blank">Download the OUTDOORA APP</a></Typography>
                                <br/>
                                <Typography>2 - Use the activation link on your mobile phone <b>or scan the QR code</b> with the phone if you are now on the desktop</Typography>
                                <br/>
                                <Typography style={{wordBreak: "break-all"}}>&nbsp;&nbsp;&nbsp;&nbsp;<b>Activation Link:</b> <a href={x.activation_link} target="_blank">{x.activation_link}</a></Typography>
                                <Typography>
                                    {!mobile && <>&nbsp;&nbsp;&nbsp;&nbsp;</>}
                                    <img src={x.qr_code_image} width={300} />
                                </Typography>
                            </>
                        )}
                        </div>
                        {(x.status === 'paied' || x.status === 'waiting_shop_approval' || x.status === 'FINISH') &&
                            <div className="col" style={{alignItems: mobile ? 'flex-start' : "flex-end", textAlign: mobile? 'start': 'end'}}>
                                <br/>
                                <Typography variant="h5">{T('free_cancel_title')}</Typography>
                                <br/>
                                <Typography style={{maxWidth: '400px'}}>{T('free_cancel_desc_long')}</Typography>
                                <br/>
                                <a href={x.cancel_link} target="_blank"><Button color="error">Cancella il tour e richiedi il rimborso</Button></a>
                            </div>
                        }
                    </div>
                </div>
            </AccordionDetails>
        </Accordion>
    )
}